import { State } from "./state";
import Mutations from "./mutations";
import Getters from "./getters";
import Actions from "./actions";
import Upload from "@/store/Abstract/Upload";
import Update from "@/store/Abstract/Update";
export default class Student {
    namespaced = true;
    state;
    mutations = Mutations;
    getters = Getters;
    actions = Actions;
    modules;
    constructor() {
        this.state = new State();
        this.modules = {
            uploadAvatar: new Upload(),
            acceptContract: new Update(),
        };
    }
}
